/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesTechnicalSettingsStatus200, GetUsersPreferencesTechnicalSettingsStatus204, GetUsersPreferencesTechnicalSettingsStatus401 } from '../types/GetUsersPreferencesTechnicalSettings'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesTechnicalSettings } from '../clients/getUsersPreferencesTechnicalSettings'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersPreferencesTechnicalSettingsQueryKey = () => [{ url: '/users/preferences/technical-settings/' }] as const

type GetUsersPreferencesTechnicalSettingsQueryKey = ReturnType<typeof getUsersPreferencesTechnicalSettingsQueryKey>

export function getUsersPreferencesTechnicalSettingsQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesTechnicalSettingsQueryKey()
  return queryOptions<GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>, GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesTechnicalSettings({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/technical-settings/}
 */
export function useGetUsersPreferencesTechnicalSettings<TData = GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, TQueryData = GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, TQueryKey extends QueryKey = GetUsersPreferencesTechnicalSettingsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesTechnicalSettingsQueryKey()

  const queryResult = useQuery({
   ...getUsersPreferencesTechnicalSettingsQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
